import React, { FunctionComponent } from 'react';

import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { headerHeight, reduceResolution, wbp } from 'Theme';

interface Props {
    text: string;
    children?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            'position': 'relative',
            'display': 'inline-flex',

            '&:hover $labelContainer': {
                display: 'block'
            }
        },
        labelContainer: {
            zIndex: 10,
            top: headerHeight,
            left: '50%',
            display: 'none',
            position: 'absolute',
            transform: 'translateX(-50%)',
            backgroundColor: '#000',

            [theme.breakpoints.down(wbp)]: {
                borderRadius: `${reduceResolution(4)}px`,
                padding: `${reduceResolution(4)}px ${reduceResolution(10)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                borderRadius: '4px',
                padding: '4px 10px'
            }
        },
        label: {
            color: '#FFFFFF',
            fontFamily: 'Poppins',
            fontWeight: 500,
            lineHeight: '120%',
            whiteSpace: 'nowrap',
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(16)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '16px'
            }
        }
    })
);

export const HeaderIconLabel: FunctionComponent<Props> = ({ text, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            {children}
            <Box className={classes.labelContainer}>
                <Typography className={classes.label}>{text}</Typography>
            </Box>
        </div>
    );
};

export default HeaderIconLabel;
